import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

// Convert camelCase to PascalCase for .NET binding
const toPascalCase = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const createFormData = (data: any, photoFile?: File | null) => {
    const formData = new FormData();
    
    // Add all mannequin data as form fields (matching .NET property names - PascalCase)
    Object.keys(data).forEach((key) => {
        const value = data[key];
        
        // Skip undefined, null, and 'photo' field
        if (value === undefined || value === null || key === 'photo') {
            return;
        }
        
        // Convert key to PascalCase for .NET binding
        const pascalKey = toPascalCase(key);
        
        // Convert to string for FormData
        // Boolean values will be 'true' or 'false'
        // Numbers will be converted to string
        formData.append(pascalKey, value.toString());
    });
    
    // Add photo file if exists
    if (photoFile) {
        formData.append('photo', photoFile);
    }
    
    return formData;
};

const PostMannequin = (data: any, photoFile?: File | null): Promise<any> => {
    const formData = createFormData(data, photoFile);
    return request({
        url: ApiURL.Command.StudioCommandURLs.MannequinCommandURL.PostMannequin,
        method: RequestType.POST,
        data: formData,
        // Tell axios wrapper to skip Content-Type override for FormData
        skipContentType: true,
    });
};

const PutMannequin = (data: any, photoFile?: File | null): Promise<any> => {
    const formData = createFormData(data, photoFile);
    return request({
        url: ApiURL.Command.StudioCommandURLs.MannequinCommandURL.PutMannequin + '/' + data.id,
        method: RequestType.PUT,
        data: formData,
        // Tell axios wrapper to skip Content-Type override for FormData
        skipContentType: true,
    });
};

const DeleteMannequin = (id: number): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.MannequinCommandURL.DeleteMannequin + '/' + id,
        method: RequestType.DELETE,
    });

export const MannequinCommand = {
    PostMannequin,
    PutMannequin,
    DeleteMannequin,
};

